export default __webpack_public_path__ + "static/media/Quarter.afc9ae9f.png";